import { styled } from "styled-components";
import { ImageComponent } from "../../../core/components/ImageComponent";
import {
  getCurrentPracticeId,
  getPracticeLogoUrlById,
} from "../../../core/store/chainSlice";
import { useMainStore } from "../../../core/store/mainStore";

export const LogoComponent = () => {
  const practiceId = useMainStore(getCurrentPracticeId);
  const logoUrl = useMainStore((state) =>
    getPracticeLogoUrlById(state, practiceId || ""),
  );
  return logoUrl ? (
    <LogoImage src={logoUrl} alt="Practice Logo" imageFit="contain" />
  ) : null;
};

const LogoImage = styled(ImageComponent)`
  height: clamp(36px, 5vw, 72px);
  width: 100%;
  max-width: 100%;
  object-fit: contain;
`;
